import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

// The URL of the provided Swagger JSON document
const SWAGGER_URL = "https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/documents/YXBwbGljYXRpb24vanNvbg==/85fcaac7a66bec45997648745e829b8d.json";

const ApiDocs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-brand-cream pt-32 pb-20 px-6">
      <div className="container mx-auto max-w-6xl">
        
        {/* Header */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-8">
          <div>
            <h1 className="font-serif text-3xl uppercase tracking-widest text-brand-olive">API Documentation</h1>
            <p className="text-brand-olive/50 text-[10px] font-black uppercase tracking-widest mt-2">Interactive Swagger UI Portal</p>
          </div>
          <Link 
            to="/admin" 
            className="flex items-center gap-2 px-6 py-3 bg-white text-[10px] font-black uppercase tracking-widest text-brand-olive border border-brand-olive/10 hover:bg-brand-olive hover:text-white transition-all shadow-sm"
          >
            <SafeIcon icon={FiIcons.FiArrowLeft} className="text-sm" /> 
            Back to Dashboard
          </Link>
        </div>
        
        {/* Swagger UI Container */}
        <div className="bg-white p-4 md:p-8 shadow-xl border border-brand-olive/5 rounded-sm overflow-hidden">
          <SwaggerUI url={SWAGGER_URL} />
        </div>

      </div>
    </div>
  );
};

export default ApiDocs;